export enum AuthStateEnum {
  INITIAL = 'initial',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
}
